/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DemoRefreshRequest
 */
export interface DemoRefreshRequest {
    /**
     * 
     * @type {string}
     * @memberof DemoRefreshRequest
     */
    customerName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DemoRefreshRequest
     */
    personalize?: boolean;
}

/**
 * Check if a given object implements the DemoRefreshRequest interface.
 */
export function instanceOfDemoRefreshRequest(value: object): value is DemoRefreshRequest {
    return true;
}

export function DemoRefreshRequestFromJSON(json: any): DemoRefreshRequest {
    return DemoRefreshRequestFromJSONTyped(json, false);
}

export function DemoRefreshRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemoRefreshRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'customerName': json['customer_name'] == null ? undefined : json['customer_name'],
        'personalize': json['personalize'] == null ? undefined : json['personalize'],
    };
}

  export function DemoRefreshRequestToJSON(json: any): DemoRefreshRequest {
      return DemoRefreshRequestToJSONTyped(json, false);
  }

  export function DemoRefreshRequestToJSONTyped(value?: DemoRefreshRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customer_name': value['customerName'],
        'personalize': value['personalize'],
    };
}

